import { compileRow } from './markup.ts';
import type { Row } from './types.ts';

export type HeaderMode = 'idle' | 'entering' | 'searching';

export interface HeaderInput {
  service: string;
  mode: HeaderMode;
  /** Page on screen (idle), or the number being searched for. */
  page: number;
  /** Digits typed so far when entering. */
  entry?: string;
  sub?: number;
  subCount?: number;
  now: Date;
}

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const pad2 = (n: number) => String(n).padStart(2, '0');

/**
 * Row 0 as a real set displays it: eight address characters
 * (`P100 1/2`, `P1..`, or the rolling number while searching) followed by
 * 32 characters of header text ending in the clock.
 */
export function headerParts(h: HeaderInput): { address: string; text: string } {
  let address: string;
  if (h.mode === 'entering') address = 'P' + (h.entry ?? '').padEnd(3, '.');
  else address = 'P' + String(h.page);
  if (h.mode === 'idle' && h.subCount && h.subCount > 1 && h.sub) {
    const ind = `${h.sub}/${h.subCount}`;
    address += ' ' + (address.length + 1 + ind.length <= 8 ? ind : String(h.sub));
  }
  address = address.padEnd(8).slice(0, 8);

  const d = h.now;
  const date = `${DAYS[d.getDay()]} ${pad2(d.getDate())} ${MONTHS[d.getMonth()]}`;
  const clock = `${pad2(d.getHours())}:${pad2(d.getMinutes())}/${pad2(d.getSeconds())}`;
  const service = h.service.slice(0, 8);
  const middle = `${service} ${h.mode === 'entering' ? '   ' : String(h.page)} ${date}`;
  const text = (' ' + middle).padEnd(32 - clock.length).slice(0, 32 - clock.length) + clock;
  return { address, text };
}

export function headerRow(h: HeaderInput): Row {
  const { address, text } = headerParts(h);
  return compileRow(address + text);
}
